import { createContext, useCallback, useContext, useState } from 'react';
import en from './en';
import de from './de';
import es from './es';

const DICTS = { en, de, es };
export const LANGS = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'de', label: 'DE', name: 'Deutsch' },
  { code: 'es', label: 'ES', name: 'Español' },
];

const LanguageContext = createContext(null);

function resolve(dict, path) {
  return path.split('.').reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), dict);
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('gyeno_lang') || 'en');

  const changeLang = useCallback((code) => {
    setLang(code);
    localStorage.setItem('gyeno_lang', code);
    document.documentElement.lang = code;
  }, []);

  const t = useCallback(
    (path) => resolve(DICTS[lang], path) ?? resolve(en, path) ?? path,
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
